export default __webpack_public_path__ + "static/reason_2-0c4016ebb673a29f9d7a1081b166b732.png";